import { Chip, Grid, makeStyles, Table, TableBody, TableCell, TableHead, TableRow } from "@material-ui/core";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { handleRoutesUpdate } from "../../actions/sortingMachineManagementActions";
import { getOpenCreateEditSortingMachineDialog } from "../../reducers/uiSlice";
import AllRoutes from "./AllRoutes";
import FilterConfig from "./FilterConfig";
import _ from 'lodash';
import moment from "moment/moment";

const useStyles = makeStyles((theme) => ({
    root: {
        height: '80vh',
        width: '100%',
        '& .MuiTableCell-head': {
            color: '#707070 !important',
            borderBottom: 'none'
        },
        '& .MuiTableCell-root': {
            paddingTop: '10px !important',
            paddingBottom: '10px !important',
        }
    },
    titleStyle: {
        backgroundColor: '#292929',
        marginTop: 40,
        padding: 20,
        borderTop: '1px solid #707070',
        borderLeft: '1px solid #707070',
        borderRight: '1px solid #707070',
        height: '8vh',
        color: 'white',
        width: '100%'
    },
    tableStyle: {
        backgroundColor: '#292929',
        borderBottom: '1px solid #707070',
        borderLeft: '1px solid #707070',
        borderRight: '1px solid #707070',
        height: '70vh',
        overflowY: 'scroll',
        overflowX: 'hidden'
    },
    headStyle: {
        borderTop: '1px solid #707070'
    },
    gridStyle: {
        cursor: 'pointer',
        color: '#FF9D00',
        width: 40,
        paddingTop: 5,
        paddingBottom: 5,
        borderRadius: 4,
        border: "#FF9D00 1px solid"
    },
    presetStyle: {
        marginBottom: 20,
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        width: 'fit-content',
        padding: 5
    },
    rowSelected: {
        border: '#FF9D00 2px solid'
    },
    infoStyle: {
        fontSize: 14,
        fontWeight: 400,
        color: 'var(--off-white-60, rgba(251, 251, 251, 0.60))',
        marginTop: 12,
        marginBottom: 12
    },
    infoDetailStyle: {
        marginRight: 14
    }
}));

function SortingPlanDetail(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { t } = useTranslation('sortingMachineManagement');

    const dialogObj = useSelector(getOpenCreateEditSortingMachineDialog);
    const routesUpdate = useSelector(state => state.smmReducer.routesUpdate);
    const presetSaved = useSelector(state => state.smmReducer.preset);

    const [totalGrids, setTotalGrids] = useState([]);
    const [gridSelected, setGridSelected] = useState();
    const [planName, setPlanName] = useState();
    const [machineCode, setMachineCode] = useState();
    const [sortingType, setSortingType] = useState();
    const [warehouse, setWarehouse] = useState();

    const handleTotalGrids = (arr) => {
        let grids = [];
        for (const slot in arr) {
            let added = false;
            if (dialogObj.type === 'EDIT') {
                let presetConfigs = presetSaved.presetGroup;
                if (Object.keys(presetConfigs).length > 0) {
                    for (const key in presetConfigs) {
                        if (arr[slot].slot_no + '' === key) {
                            let routes = [];
                            presetConfigs[key].filter((config) => {
                                routes.push({
                                    'checked': true,
                                    'inserted': true,
                                    'route_id': config.sorting_number,
                                    'route_name': config.sorting_name,
                                    'warehouse': config.warehouse
                                })
                            })
                            grids.push({
                                'id': arr[slot].slot_no,
                                'routes': routes
                            })
                            added = true;
                        }
                    }
                }
                if (!added) {
                    grids.push({ 'id': arr[slot].slot_no })
                }
            } else {
                grids.push({ 'id': arr[slot].slot_no })
            }
        }
        setTotalGrids(grids);
    }

    const handleGridSelect = (id) => {
        let clone = [...totalGrids];
        clone.map((grid) => {
            grid.selected = grid.id === id;
        })
        setTotalGrids(clone);
        setGridSelected(id);
    }

    const handleModify = (type, routeId) => {
        let gridsClone = [...totalGrids];
        let routesClone = [...routesUpdate];
        gridsClone.map((grid) => {
            if (grid.id === gridSelected) {
                routesClone.map((routes) => {
                    routes.routes.map((route) => {
                        if (type === 'delete') {
                            if (route.route_id + '' === routeId + '') {
                                route.checked = false;
                                route.inserted = false;
                                grid.routes = grid.routes.filter((item) => item.route_id !== routeId);
                                routes.allChecked = false;
                                routes.allInserted = false;
                            }
                        } else {
                            if (route.checked && !route.inserted) {
                                const routeObj = {
                                    route_id: route.route_id,
                                    route_name: route.route_name,
                                    warehouse: warehouse
                                };
                                if (grid?.routes?.length > 0) {
                                    grid.routes.push(routeObj);
                                } else {
                                    grid.routes = [routeObj];
                                }
                                route.inserted = true;
                                routes.allInserted = routes.allChecked;
                            }
                        }
                    })
                })
            }
        })
        setTotalGrids(gridsClone);
        dispatch(handleRoutesUpdate(routesClone));
    }

    const handleFilterParams = (plan, code, type) => {
        setPlanName(plan);
        setMachineCode(code);
        setSortingType(type);
    }

    const handleWarehouse = (warehouse) => {
        setWarehouse(warehouse);
    }

    useEffect(() => {
        if (planName && machineCode && sortingType && totalGrids?.length > 0 && dialogObj.open) {
            let clone = [];
            totalGrids.filter((grid) => {
                if (grid?.routes?.length > 0) {
                    grid.routes.filter((route) => {
                        clone.push({
                            'sorting_number': route.route_id,
                            'grid': grid.id,
                            'warehouse': route.warehouse
                        })
                    })
                }
            })
            props.handleParams({
                'name': planName + '',
                'machine_code': machineCode + '',
                'sorting_type': sortingType + '',
                'config_items': clone
            })
        }
    }, [planName, machineCode, sortingType, totalGrids])

    return (
        <Grid container className={classes.root}>
            <Grid item xs={12}>
                <FilterConfig
                    sortingCenters={props.sortingCenters}
                    handleTotalGrids={handleTotalGrids}
                    handleFilterParams={handleFilterParams}
                    type={dialogObj.type}
                    open={dialogObj.open}
                />
            </Grid>
            {
                dialogObj.type === 'EDIT' &&
                <Grid
                    item
                    xs={12}
                    className={classes.infoStyle}
                >
                    <span
                        className={classes.infoDetailStyle}
                    >
                        {t('creation_date')}{presetSaved?.preset?.create_time ? moment.unix(Number(presetSaved?.preset?.create_time)).format("YYYY-MM-DD") : '--'}
                    </span>
                    <span
                        style={{ borderRight: 'solid 1px', paddingRight: 14 }}
                    >
                        {t('created_by')}{presetSaved?.preset?.creator || '--'}
                    </span>
                    <span
                        style={{ paddingLeft: 14, marginRight: 14 }}
                    >
                        {t('last_update')}{presetSaved?.preset?.update_time ? moment.unix(Number(presetSaved?.preset?.update_time)).format("YYYY-MM-DD") : '--'}
                    </span>
                    <span
                        className={classes.infoDetailStyle}
                    >
                        {t('updated_by')}{presetSaved?.preset?.update_by || '--'}
                    </span>
                </Grid>
            }
            <Grid item xs={9} className={classes.tableStyle} style={dialogObj.type === 'CREATE' ? { borderTop: '1px solid #707070' } : { borderTop: 'none' }}>
                <Table>
                    <TableHead className={classes.headStyle}>
                        <TableRow className={classes.tableRowColor}>
                            <TableCell align="left" style={{ width: '10%' }}>{t('compt')}</TableCell>
                            <TableCell align="left">{t('assigned_routes')}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            dialogObj.type === 'CREATE' &&
                            totalGrids.length > 0 &&
                            totalGrids.map((grid, index) => (
                                <TableRow style={index % 2 ? { background: "#424242" } : { background: "#303030" }} className={grid.selected ? classes.rowSelected : ''}>
                                    <TableCell align="center">
                                        <div
                                            className={classes.gridStyle}
                                            onClick={() => handleGridSelect(grid.id)}
                                            style={grid.selected ? { backgroundColor: "#FF9D00", color: 'black' } : {}}
                                        >
                                            {grid.id}
                                        </div>
                                    </TableCell>
                                    <TableCell style={{ marginRight: 5, lineHeight: '40px' }}>
                                        {
                                            grid?.routes?.length > 0 &&
                                            grid.routes.map((route) => (
                                                <Chip
                                                    label={route.route_name}
                                                    style={{ marginRight: 5 }}
                                                    onDelete={() => handleModify('delete', route.route_id)}
                                                    disabled={!grid.selected}
                                                />
                                            ))
                                        }
                                    </TableCell>
                                </TableRow>
                            ))
                        }
                        {
                            dialogObj.type === 'EDIT' &&
                            totalGrids.length > 0 &&
                            totalGrids.map((grid, index) => (
                                <TableRow style={index % 2 ? { background: "#424242" } : { background: "#303030" }} className={grid.selected ? classes.rowSelected : ''}>
                                    <TableCell align="center">
                                        <div
                                            className={classes.gridStyle}
                                            onClick={() => handleGridSelect(grid.id)}
                                            style={grid.selected ? { backgroundColor: "#FF9D00", color: 'black' } : {}}
                                        >
                                            {grid.id}
                                        </div>
                                    </TableCell>
                                    <TableCell style={{ marginRight: 5, lineHeight: '40px' }}>
                                        {
                                            grid?.routes?.length > 0 &&
                                            grid.routes.map((route) => (
                                                <Chip
                                                    label={route.route_name}
                                                    style={{ marginRight: 5 }}
                                                    onDelete={() => handleModify('delete', route.route_id)}
                                                    disabled={!grid.selected}
                                                />
                                            ))
                                        }
                                    </TableCell>
                                </TableRow>
                            ))
                        }
                    </TableBody>
                </Table>
            </Grid>
            <Grid item xs={3} className={classes.tableStyle} style={{ backgroundColor: '#3A3A3A', padding: 15, color: 'white', borderTop: '1px solid #707070' }}>
                <AllRoutes
                    handleInsert={handleModify}
                    handleWarehouse={handleWarehouse}
                    totalGrids={totalGrids}
                />
            </Grid>
        </Grid>
    );
}

export default SortingPlanDetail;